import { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import IconSave from '../../components/icons/IconSave';
import '../../css/modals.css';
import '../../css/games.css';

// Create/edit modal for a Set (a named, shareable bundle of games).
export default function SetModal({ modalState, setId, onClose, onSaved }) {
   const navigate = useNavigate();
   const isOpen = modalState === 'create' || modalState === 'edit';
   const isEdit = modalState === 'edit';
   const [name, setName] = useState('');
   const [initialName, setInitialName] = useState('');
   const [saving, setSaving] = useState(false);
   const [error, setError] = useState('');

   useEffect(() => {
      if(!isOpen) return;
      if(isEdit && setId) {
         axios.get('/api/set/' + setId, { withCredentials: true })
            .then(response => {
               const nextName = response.data.name || '';
               setName(nextName);
               setInitialName(nextName);
            })
            .catch(err => {
               if(err.response && err.response.status === 401) navigate('/login');
            });
      } else {
         setName('');
         setInitialName('');
      }
      setError('');
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [modalState, setId]);

   if(!isOpen) return '';

   const dirty = name.trim() !== initialName;
   const canSave = name.trim().length > 0 && (isEdit ? dirty : true);

   const handleSave = () => {
      if(!canSave || saving) return;
      setSaving(true);
      setError('');
      const payload = { name: name.trim() };
      const request = isEdit
         ? axios.put('/api/set/' + setId, JSON.stringify(payload), { withCredentials: true, headers: { 'Content-Type': 'application/json' } })
         : axios.post('/api/set', JSON.stringify(payload), { withCredentials: true, headers: { 'Content-Type': 'application/json' } });
      request.then(response => {
         setSaving(false);
         onSaved(response.data);
      }).catch(err => {
         setSaving(false);
         if(err.response && err.response.status === 401) { navigate('/login'); return; }
         setError('Не вдалося зберегти набір');
      });
   };

   const stopProp = e => e.stopPropagation();

   return (
      <div className="modal-update" onClick={onClose} style={{ display: 'flex' }}>
         <div className="modal-window games-modal-window" onClick={stopProp}>
            <h3 className="modal-w-title">{isEdit ? 'Редагування набору' : 'Новий набір'}</h3>

            <div className="games-modal-field">
               <label className="games-modal-label">Назва</label>
               <input className="games-modal-input" type="text" value={name}
                  placeholder="Наприклад: Урок 3 — минулий час"
                  onChange={e => setName(e.target.value)}
                  onKeyDown={e => { if(e.key === 'Enter') handleSave(); }} autoFocus />
            </div>

            {error ? <div className="games-modal-error">{error}</div> : ''}

            <div className="games-modal-actions">
               <button type="button" className="games-modal-save-btn" disabled={!canSave || saving} onClick={handleSave}>
                  <IconSave />
                  {saving ? 'Збереження...' : 'Зберегти'}
               </button>
            </div>
         </div>
      </div>
   );
}
